import React from 'react';
import {Helmet} from "react-helmet";

function Head({title, desc}) {
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{title || 'Eurey Noguchi'}</title>
            <meta name="description" content={desc || "Personal website, portfolio, and blog for Eurey (Yuri) Noguchi."} />
            <link rel="canonical" href="https://eureyuri.github.io/" />

             {/* <!-- Open Graph / Facebook --> */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://eureyuri.github.io/" />
            <meta property="og:title" content="Eurey Noguchi" />
            <meta property="og:description" content="Personal website, portfolio, and blog for Eurey (Yuri) Noguchi." />
            <meta property="og:image" content="../images/favicon.png" />

            {/* <!-- Twitter --> */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content="https://eureyuri.github.io//" />
            <meta property="twitter:title" content="Eurey Noguchi" />
            <meta property="twitter:description" content="Personal website, portfolio, and blog for Eurey (Yuri) Noguchi." />
            <meta property="twitter:image" content="../images/favicon.png" />
        </Helmet>
    );
}

export default Head;